import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4d96c716&lang=css"

const __exports__ = script;

export default __exports__